module.exports = __webpack_public_path__ + "static/text-logo-31036830772a62bf50c66427d7a1f2c0.png";